"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _CwImage = _interopRequireDefault(require("../../cwimage/CwImage"));

var _CwDataGrid = _interopRequireDefault(require("../CwDataGrid.scss"));

var CellBool = function CellBool(props) {
  // calculate boolValue and titleValue
  var boolValue = false;
  var titleValue = 'False';

  if (typeof props.row[props.col.key] === 'string') {
    titleValue = props.row[props.col.key];

    if (props.row[props.col.key] !== 'Offline') {
      boolValue = true;
    }
  } else if (props.row[props.col.key] === true) {
    boolValue = true;
    titleValue = 'True';
  }

  return _react.default.createElement("div", {
    className: _CwDataGrid.default.cell,
    title: titleValue,
    style: {
      width: props.col.width,
      padding: '7px 0'
    }
  }, !boolValue && _react.default.createElement(_CwImage.default, {
    "data-cw-grid-cell-bool-false": true,
    src: props.falseImage,
    className: (0, _classnames.default)(_CwDataGrid.default.boolStatus, _CwDataGrid.default.false)
  }), boolValue && _react.default.createElement(_CwImage.default, {
    "data-cw-grid-cell-bool-true": true,
    src: props.trueImage,
    className: (0, _classnames.default)(_CwDataGrid.default.boolStatus, _CwDataGrid.default.true)
  }));
};

CellBool.propTypes = {
  col: _propTypes.default.object.isRequired,
  row: _propTypes.default.object.isRequired,
  trueImage: _propTypes.default.string,
  falseImage: _propTypes.default.string
};
CellBool.defaultProps = {
  trueImage: '',
  falseImage: ''
};
var _default = CellBool;
exports.default = _default;